import * as constant from './constant'
export function findValue(param) {
    let selected
    selected = param.map((el) => {
        return el.value;
    })
    return selected
}

export function makeMultiselectObject(multiselectParam) {
    let selected
    selected = multiselectParam.map((el) => {
        let obj = {}
        obj.label = el
        obj.value = el
        return obj;
    })
    return selected
}

export function checkSearchParameter(param, searchParameterObj, stateList) {
    let reqbody;

    let search = searchParameterObj['s']
    if(searchParameterObj['country'] == constant.INDIA){
        switch (param) {
            case constant.GST:
                reqbody = {
                    counterpartyName: "",
                    gstNo: search,
                    states: stateList ? stateList : []
                }
                break;
            case constant.NAME:
                reqbody = {
                    counterpartyName: search,
                    gstNo: "",
                    states: stateList ? stateList : []
                }
                break;
            case constant.PAN:
                reqbody = {
                    panNo : search,
                    states: stateList ? stateList : []
                }
                break;
            case constant.CIN:
                reqbody = {
                    cin : search,
                    states: stateList ? stateList : []
                }
                break;
            default:
                reqbody = null;
        }
    }else{
        reqbody = {
            counterpartyName : search,
            country: searchParameterObj['country'],
            countryCode : searchParameterObj['countryCode'],
            states: []
        }
    }
    
    return reqbody;
}

export function sortByKey(searchData, param, flag) {
    let sortedData
    if (flag === true) {
        sortedData = param !== constant.EXISTSINPROTFOLIO ? searchData.sort((a, b) => (a[param].toLowerCase() > b[param].toLowerCase()) ? 1 : ((b[param].toLowerCase() > a[param].toLowerCase()) ? -1 : 0)) :
            searchData.sort((a, b) => (a[param] > b[param]) ? 1 : ((b[param] > a[param]) ? -1 : 0))
    }
    else {
        sortedData = param !== constant.EXISTSINPROTFOLIO ? searchData.sort((a, b) => (a[param].toLowerCase() < b[param].toLowerCase()) ? 1 : ((b[param].toLowerCase() < a[param].toLowerCase()) ? -1 : 0)) :
            searchData.sort((a, b) => (a[param] < b[param]) ? 1 : ((b[param] < a[param]) ? -1 : 0));
    }
    return sortedData
}

export const getSearchParameter = (searchParam) => {
    const params = new URLSearchParams(searchParam);
    let parameterObj = {
        s: params.get('s'),
        country: params.get('country'),
        countryCode: params.get('countryCode')
    }
    return parameterObj;
}